/*
https://splidejs.com/guides/getting-started/
*/

import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function() {
    const slider = document.querySelector('.procedure-timeline .splide');

    if( slider ) {
        var splide = new Splide( '.procedure-timeline .splide' , {
            type: 'slide',
            speed: 1000,
            arrows: true,
            pagination: false,
            perPage: 3.5,
            perMove: 1,
            focus  : 0,
            drag: 'free',
            waitForTransition: false,
            arrowPath: 'm15.5 0.932-4.3 4.38',
            breakpoints: {
                1290: {
                    perPage: 2.5,
                },
                960: {
                    perPage: 1.5,
                },
                768: {
                    perPage: 1.2,
                },
            }
        });

        splide.mount();
    }
});